import { Input } from "@rebass/forms";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Flex, Image } from "rebass";
import styled from "styled-components";
import { AiFillEye } from "react-icons/ai";
import { userActions } from "../../logic/actions";
import FvlLogo from "../../static/images/FvlLogoDev.png";
// import FvlLogo from "../../static/images/LogoFvlTransparent.png";
import BgLogin from "../../static/images/hero_fvl.jpg";
import { getLocalizedString } from "../../utils";
import facebookLogo from "../../static/images/facebook.svg";
import instagramLogo from "../../static/images/instagram.svg";
import pinterestLogo from "../../static/images/pinterest.svg";
import twitterLogo from "../../static/images/twitter-logo-white.png";

const LoginFvl = () => {
  const { register, handleSubmit, errors } = useForm();
  const dispatch = useDispatch();
  const { error } = useSelector((state) => state.authentication);

  const [showPwd, setShowPwd] = useState(false);

  const onSubmit = (data) => {
    dispatch(userActions.login(data.username, data.password));
  };

  return (
    <Flex bg="#44494d" width={1} height="100vh">
      <Flex height="100%" width="35%">
        <img alt="" src={BgLogin} style={{ width: "100%", height: "100%" }} />
      </Flex>
      <Flex
        width="55%"
        height="100%"
        pl="150px"
        flexDirection="column"
        justifyContent="center"
        style={{ gap: "10px" }}
      >
        <img
          src={FvlLogo}
          alt=""
          style={{ marginBottom: "50px", width: "200px", objectFit: "contain" }}
        />
        <Flex
          as="form"
          onSubmit={handleSubmit(onSubmit)}
          flexDirection="column"
          width={1 / 3}
        >
          <Flex
            flexDirection="column"
            // alignItems="center"
            justifyContent="center"
            width="100%"
          >
            <Flex flexDirection="column" minHeight="80px">
              <InputLoginFvl
                ref={register({ required: true })}
                placeholder="User"
                name="username"
              />
              <Flex>
                {errors.username && (
                  <span
                    style={{
                      color: "#6d7174",
                      marginLeft: "10px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    This field is required
                  </span>
                )}
                {error && (
                  <span
                    style={{
                      color: "#6d7174",
                      marginLeft: "10px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Wrong Username
                  </span>
                )}
              </Flex>
            </Flex>
            <Flex flexDirection="column" minHeight="80px">
              <InputLoginFvl
                ref={register({ required: true })}
                type={showPwd ? "text" : "password"}
                placeholder="Password"
                name="password"
              />
              <Flex>
                {errors.password && (
                  <span
                    style={{
                      color: "#6d7174",
                      marginLeft: "10px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    This field is required
                  </span>
                )}
                {error && (
                  <span
                    style={{
                      color: "#6d7174",
                      marginLeft: "10px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Wrong Password
                  </span>
                )}
              </Flex>
            </Flex>

            <div
              style={{ position: "relative", left: "88%", top: "-69px" }}
              onClick={() => setShowPwd((p) => !p)}
            >
              <AiFillEye size="24px" color="#6d7174" />
            </div>
          </Flex>
          <Flex style={{ gap: "10px" }} alignItems="center">
            <ButtonLogin type="submit">LOGIN</ButtonLogin>
          </Flex>
          <Flex mt="20px">
            <LinkCustom color="white">
              {getLocalizedString("LOST_PWD")}
            </LinkCustom>
          </Flex>
        </Flex>
        <Flex
          pr="20px"
          style={{ position: "absolute", bottom: "40px", right: 0 }}
        >
          <Flex>
            <a
              className="pl-3"
              style={{ textDecoration: "none" }}
              href="https://www.facebook.com/HernoSpa/"
              target="_blank"
              rel="noreferrer"
            >
              <Image src={facebookLogo} m={2} height={21}></Image>
            </a>

            <a
              className="pl-3"
              style={{ textDecoration: "none" }}
              href="https://twitter.com/Herno_official"
              target="_blank"
              rel="noreferrer"
            >
              <Image src={twitterLogo} m={2} height={21}></Image>
            </a>

            <a
              className="pl-3"
              style={{ textDecoration: "none" }}
              href="https://www.instagram.com/herno_official/"
              target="_blank"
              rel="noreferrer"
            >
              <Image src={instagramLogo} m={2} height={21}></Image>
            </a>

            <a
              className="pl-3"
              style={{ textDecoration: "none" }}
              href="https://www.pinterest.it/hernospa/"
              target="_blank"
              rel="noreferrer"
            >
              <Image src={pinterestLogo} m={2} height={21}></Image>
            </a>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        width="100%"
        height="40px"
        bg="white"
        style={{ position: "absolute", bottom: 0, left: 0 }}
        justifyContent="space-between"
        alignItems="center"
      >
        <div />
        <span>
          COPYRIGHT © HERNO S.P.A. {new Date().getFullYear()} – ALL RIGHTS
          RESERVED
        </span>
        <Flex style={{ gap: "10px" }} pr="10px">
          <LinkCustom to="/privacy">Privacy</LinkCustom>
          <LinkCustom to="/cookie">Cookie</LinkCustom>
        </Flex>
      </Flex>
    </Flex>
  );
};

const InputLoginFvl = styled(Input)`
  background-color: transparent;
  border-radius: 5px;
  border: 1px solid #6d7174;
  height: 45px;
  width: 100%;
  padding-left: 8px;
  color: white;
`;

const ButtonLogin = styled.button`
  background-color: white;
  border-radius: 5px;
  padding-inline: 10px;
  font-size: 14px;
  font-weight: bold;
  height: 30px;
`;

const LinkCustom = styled(Link)`
  color: ${({ color }) => color};
`;

export default LoginFvl;
